import { useEffect, useRef } from 'react';
import OneSignal from 'react-onesignal';
import { message } from "antd"
import { useSelector } from 'react-redux';
import type { RootState } from '../store';

export const useOneSignal = () => {
    const isInitialized = useRef(false);
    const userId = useSelector((state: RootState) => state.user.userId)

    useEffect(() => {
        const initOneSignal = async () => {
            if (isInitialized.current || !userId) return;

            if (!OneSignal.Notifications.isPushSupported()) {
                message.warning("Notifications are not supported by your browser.")
                return
            }

            isInitialized.current = true;

            const appId = import.meta.env.VITE_ONESIGNAL_APP_ID;
            if (!appId) {
                console.error('OneSignal App ID is missing!');
                return;
            }

            try {
                await OneSignal.init({
                    appId,
                    autoRegister: true,
                }).then(async () => {
                    console.log("OneSignal initialised!")
                    await OneSignal.login(userId)
                });

                await OneSignal.Notifications.requestPermission();

                const permission = Notification.permission;
                console.log("OneSignal.User.onesignalId >>> ", OneSignal.User.onesignalId, permission)

                if (permission === 'granted') {
                    message.success('Notifications enabled!');
                } else if (permission === 'denied') {
                    message.warning('You denied notification permission.');
                } else {
                    message.info('You dismissed the permission prompt.');
                }
            } catch (error) {
                console.error('OneSignal init error:', error);
            }
        };

        initOneSignal();
    }, [userId]);
};